import { render, staticRenderFns } from "./products-overview-view.vue?vue&type=template&id=31009eb2&scoped=true"
import script from "./products-overview-view.vue?vue&type=script&lang=ts"
export * from "./products-overview-view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31009eb2",
  null
  
)

export default component.exports